import React, { useEffect, useState } from 'react'
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'
import { Message } from 'primereact/message'
import LtsPassword from '../lottus/lts-password'
import storage from '../../services/stoage.service'
import { buscarTelaContrassenha } from '../../services/api-contrassenha'
import { avaliarFalhaEnvio, podeConfirmar, textosDialogo, tipoNaoSuportado } from './contrassenha.utils'

/**
 * Confirmacao de operacao financeira por contrassenha (PHOENIX-959, plano §5). O que pedir depende da empresa
 * (senha de login, por agora); o dialogo nao sabe qual e: mostra a instrucao que o back mandar e envia o que for
 * digitado. Quem confere e a rota da propria operacao.
 *
 * Props:
 * - visible
 * - onConfirmar(contrassenha): Promise da operacao. Resolveu = feito (quem chamou fecha o dialogo). Rejeitou com 403 =
 *   contrassenha recusada: o dialogo fica aberto com o texto do back. Sem resposta: fica aberto com o aviso de
 *   resultado desconhecido e sem deixar reenviar. Outra rejeicao: o dialogo fecha (onCancelar).
 * - onCancelar()
 *
 * Resultado incerto: o dialogo so trava a si mesmo. Cancelar e abrir de novo reenviaria a mesma operacao, entao a
 * operacao trava o reenvio no store (ex.: remessa de pagamento, envioGerar) - sair da tela e voltar nao libera.
 *
 * O campo usa autoComplete="new-password": com "off" o Chrome e o Firefox oferecem a senha de login salva, e quem
 * estiver numa sessao aberta em maquina alheia so precisaria escolher a sugestao.
 */
export default function ContrassenhaDialog(props) {
  const { visible, onConfirmar, onCancelar } = props
  const [tela, setTela] = useState(null)
  const [contrassenha, setContrassenha] = useState('')
  const [enviando, setEnviando] = useState(false)
  const [erro, setErro] = useState('')
  // sem resposta do back: a operacao pode ter acontecido; nao deixa reenviar daqui
  const [incerto, setIncerto] = useState(false)

  useEffect(() => {
    // limpa ao abrir e ao fechar: a contrassenha nao fica guardada no estado entre uma operacao e outra
    setContrassenha('')
    setErro('')
    setEnviando(false)
    setIncerto(false)
    if (!visible) {
      return undefined
    }
    let ativo = true
    setTela(null)
    buscarTelaContrassenha()
      .then(({ data }) => ativo && setTela(data))
      .catch(() => ativo && setTela(null))
    return () => {
      ativo = false
    }
  }, [visible])

  // o dicionario do front so e lido quando a busca no back nao trouxe os textos
  const textos = textosDialogo(tela, tela ? null : storage.getAppLabels('contrassenha'))

  const habilitado = !incerto && podeConfirmar(contrassenha, enviando, tela)

  const confirmar = () => {
    if (!habilitado) {
      return
    }
    setEnviando(true)
    setErro('')
    // new Promise, e nao Promise.resolve: um throw sincrono do onConfirmar vira rejeicao em vez de deixar o dialogo
    // preso em "enviando"
    new Promise((resolve) => resolve(onConfirmar(contrassenha)))
      .then(() => {
        setContrassenha('')
        setEnviando(false)
      })
      .catch((error) => {
        const falha = avaliarFalhaEnvio(error)
        setContrassenha('')
        setEnviando(false)
        if (falha.incerto) {
          setIncerto(true)
          setErro(textos.resultadoDesconhecido)
        } else if (falha.manterAberto) {
          setErro(falha.mensagem)
        } else {
          onCancelar()
        }
      })
  }

  const footer = (
    <div>
      <Button
        label={textos.confirmar}
        icon="pi pi-check"
        className="p-button-success"
        onClick={confirmar}
        disabled={!habilitado}
      />
      <Button
        label={textos.cancelar}
        icon="pi pi-times"
        className="p-button-danger"
        onClick={onCancelar}
        disabled={enviando}
      />
    </div>
  )

  return (
    <Dialog
      header={textos.titulo}
      visible={visible}
      appendTo={document.body}
      modal={true}
      onHide={() => !enviando && onCancelar()}
      footer={footer}
      style={{ width: '420px', maxWidth: '95vw' }}
      closable={!enviando}
    >
      <div className="p-grid p-fluid">
        {textos.instrucao ? <div className="p-col-12">{textos.instrucao}</div> : null}
        {!tipoNaoSuportado(tela) ? (
          <div className="p-col-12" style={{ marginTop: '1em' }}>
            <form
              autoComplete="off"
              onSubmit={(e) => {
                e.preventDefault()
                confirmar()
              }}
            >
              <LtsPassword
                name="contrassenha"
                label={textos.campo}
                value={contrassenha}
                onChange={(valor) => setContrassenha(valor)}
                feedback={false}
                autoFocus={true}
                autoComplete="new-password"
                disabled={enviando || incerto}
              />
            </form>
          </div>
        ) : null}
        {erro ? (
          <div className="p-col-12">
            <Message severity="error" text={erro} />
          </div>
        ) : null}
      </div>
    </Dialog>
  )
}
